import React from 'react'
import { styled } from 'styled-components'
import './Navbar.css'
import { Link } from 'react-router-dom';

const Container = styled.div`
    width: 100%;
    background: #292b48;
    height: 70px;
    color: #fff;
`;

export const Navbar = ({handleToggle}) => {
  return (
    <Container>
        <div className='nav-toggler' onClick={handleToggle}>
            <span className="icon-bar top-bar"></span>
            <span className="icon-bar middle-bar"></span>
            <span className="icon-bar bottom-bar"></span>
        </div>
        <div className='nav-img'>
            <a href="/" ><img className='img-fluid' alt="Logo" src="/assets/img/logo-400.png"/></a>
        </div>
        <Link to='/'>
            <p className='d-inline-block fs-4 ms-4 b-title'>Repository</p>
        </Link>
    </Container>
  )
}
